var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"rest-api\">\n<div class=\"row\">\n<div class=\"col-md-12\">\n<eshq-cluster-navigation></eshq-cluster-navigation>\n</div>\n</div>\n<div ui-view></div>\n</div>";
var id1="containers/rest-api/rest-api.view.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ui/src/containers/rest-api/rest-api.view.html
// module id = 813
// module chunks = 0